/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../resources/error';
import '../resources/datatypes';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "connect": {
        "nested": {
          "v2": {
            "nested": {
              "merchant_catalog": {
                "nested": {
                  "service": {
                    "nested": {
                      "CloneCategoryRequest": {
                        "fields": {
                          "idempotencyKey": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "categoryId": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "name": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "CloneCategoryResponse": {
                        "fields": {
                          "errors": {
                            "type": ".squareup.connect.v2.resources.Error",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "objects": {
                            "type": ".squareup.connect.v2.merchant_catalog.resources.CatalogObject",
                            "id": 2,
                            "rule": "repeated"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.CloneCategoryRequest && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.CloneCategoryResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE CloneCategoryRequest @ squareup/connect/v2/catalog/interfaces/clone-category.proto at 20:1
 */
export const CloneCategoryRequest = $root.lookupType('squareup.connect.v2.merchant_catalog.service.CloneCategoryRequest');
fixType(CloneCategoryRequest, {
  idempotencyKey: {
    required: true,
    notEmpty: true
  },
  categoryId: {
    required: true
  }
});
Builder.createAndAttachToType(CloneCategoryRequest);
/**
 * SOURCE CloneCategoryResponse @ squareup/connect/v2/catalog/interfaces/clone-category.proto at 54:1
 */
export const CloneCategoryResponse = $root.lookupType('squareup.connect.v2.merchant_catalog.service.CloneCategoryResponse');
fixType(CloneCategoryResponse);
Builder.createAndAttachToType(CloneCategoryResponse);